export const theme = {
    primaryDark: '#B2A4A8',
    primaryLight: '#322037',
    primaryHover: '#343078',
    mobile: '576px',
  }